import { render, staticRenderFns } from "./InputApproverFor.vue?vue&type=template&id=0b9ece3d&"
import script from "./InputApproverFor.vue?vue&type=script&lang=js&"
export * from "./InputApproverFor.vue?vue&type=script&lang=js&"
import style0 from "./InputApproverFor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InputApproverFor.vue"
export default component.exports